import React, { useState, useEffect } from "react";
import DupontCheckbox from "components/DupontCheckbox";
import { makeStyles } from "@material-ui/styles";
import { CHECKBOX_STATES } from "constants/globalConstants";

const useStyles = makeStyles(theme => ({
  checkboxContainer: {
    display: "inline-block",
    marginTop: "10px"
  }
}));

const AlarmsListHeaderCheckboxRenderer = props => {
  const classes = useStyles();
  const { field, displayName, headerProps } = props;
  const [isChecked, setIsChecked] = useState(headerProps[field] === CHECKBOX_STATES.CHECKED);
  const [isIndeterminate, setIndeterminate] = useState(headerProps[field] === CHECKBOX_STATES.INDETERMINATE);

  useEffect(() => {
    setIsChecked(headerProps[field] === CHECKBOX_STATES.CHECKED);
    setIndeterminate(headerProps[field] === CHECKBOX_STATES.INDETERMINATE);
  }, [headerProps]);

  const selectionChangeHandler = val => {
    props.context.onColumnSelection(field, val);
    setIndeterminate(false);
  };

  return (
    <span className={classes.checkboxContainer}>
      <DupontCheckbox
        name={displayName}
        customClass={"checkbox--label"}
        indeterminate={isIndeterminate}
        checked={isChecked}
        labelText={displayName}
        onChange={selectionChangeHandler}
      />
    </span>
  );
};

export default AlarmsListHeaderCheckboxRenderer;
